<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="overflow-auto">
          <ts-loading-banner :loading="inquiry_search">
            <div id="inquiry-list">
              <table class="table table-hover ui-table ts-table">
                <thead>
                  <tr>
                    <th style="width: 24%;">{{ $t('quotation.studentName') }}</th>
                    <th style="width: 42%;">{{ $t('quotation.sex') }}</th>
										<th>{{ $t('quotation.studyTime') }}</th>
                  </tr>
                  <tr>
                    <th colspan="6">
                      <input
                        v-model.trim="searchValue"
                        type="text"
                        class="form-control"
                        :class="{ loading: inquiry_search }"
                        :placeholder="$t('quotation.searchStudent')"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(inquiry, index) in inquiryResource"
                    :key="index"
                    @dblclick="selectStudent(inquiry, index)"
                  >
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{ inquiry.full_name_en }}
                    </td>
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{ inquiry.gender }}
                    </td>
										<td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
										  {{ inquiry.study_time +' | '+ inquiry.session }}
									  </td>
                  </tr>
                </tbody>
              </table>
              <div class="validate" v-if="errors.has('inquiry_id')">
                {{ errors.first('inquiry_id') }}
              </div>
            </div>
          </ts-loading-banner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'quotationInquiryList',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      inquiry_search: false,
      searchValue: '',
      inquiryResource: [],
      errors: new Errors(),
      selectedIndex: null
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('quotation', ['formViewModel']),
    selectStudent(inquiry, index) {
      this.selectedIndex = index
      this.model.inquiry_id = inquiry.inquiry_id
      this.model.study_time = inquiry.study_time + ' | ' + inquiry.session
    },
    searchStudent(params) {
      this.inquiry_search = true
      this.inquiryResource = []
      this.formViewModel({
				params,
				fnName: 'inquiry'
			})
        .then(response => {
          this.inquiryResource = response.inquiry
        })
        .finally(() => {
          this.inquiry_search = false
        })
    }
  },
  watch: {
    searchValue: debounce(function(value) {
      if (value) {
        this.searchStudent({
          search: value,
          page: -1
        })
      }
    }, 500),
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#inquiry-list {
  max-height: 31vh;
  height: 30vh;
  overflow: scroll;
}
table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}
table > tbody > tr > td {
  cursor: pointer;
}
.selected-class {
  border-bottom: 1px solid #69bafb;
  border-top: 1px solid #69bafb;
  background: #1d68b3;
  color: white;
  font-weight: 700;
}
.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
